import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import Modal from 'srcReact/components/common2/Modal'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import { redirectToPage } from 'srcReact/helpers/history'

const WorkplaceLimitPopin = ({ isPopinOpen, handleClosePopin, isNative, isBillable, workplaceLimit }) => {
  const { t } = useTranslation()

  const getWorkplaceLimit = (workplaceLimit) => {
    switch (workplaceLimit) {
      case 1:
        return 'oneWorkplaceLimit'
      case 2:
        return 'twoWorkplaceLimit'
      case 1:
        return 'fiveWorkplaceLimit'
      default:
        return ''
    }
  }

  const handleRedirectTo = () => {
    redirectToPage('/0/support', isNative)
    handleClosePopin()
  }

  return (
    <Modal
      isOpen={isPopinOpen}
      handleClose={handleClosePopin}
      title={t(`billing.popin.${[getWorkplaceLimit(workplaceLimit)]}.title`)}
      subTitle={
        isBillable
          ? t(`billing.popin.${[getWorkplaceLimit(workplaceLimit)]}.ownerText`)
          : t(`billing.popin.${[getWorkplaceLimit(workplaceLimit)]}.text`)
      }
      titleCSS={styles.title}>
      <img className={styles.image} src={`${config.assetUrl}/images/process.svg`} alt='void' />
      {isBillable ? (
        <Button
          text={t(`billing.popin.${[getWorkplaceLimit(workplaceLimit)]}.ownerBtnText`)}
          size='large'
          style={workplaceLimit === 5 ? 'orange' : 'primary'}
          handleClick={handleRedirectTo}
        />
      ) : (
        <React.Fragment>
          <Button
            customStyle={styles.okButton}
            text={t(`billing.popin.${[getWorkplaceLimit(workplaceLimit)]}.btnPrimary`)}
            size='large'
            handleClick={handleClosePopin}
          />
          <AnchorLink className={styles.contactButton} handleClick={handleRedirectTo}>
            {t('global.contactUs')}
          </AnchorLink>
        </React.Fragment>
      )}
    </Modal>
  )
}

export default WorkplaceLimitPopin
